import { defineStore } from 'pinia';
import network from '../network';
import { useHot } from '../useHot';

export const useBalanceListStore = defineStore({
  id: 'balanceList',
  state: () => {
    return {
      balanceList: {}, // 1币币账户, 2期货账户, 3法币账户, 4信托账户
      xinTuoBits: [], // 信托账户 划转的币的列表
    };
  },
  getters: {},
  actions: {
    /**
     * @name 转换所有余额
     * @param @requires payload.type 1 只回收上分记录的第三方
     */
    async reqTransitionAllYe(payload: any = {}) {
      const { hotData, is_try } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data: any = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
        type: payload?.play_id?.includes(',') ? 3 : 1,
      };
      data.cust_account_type = userInfo.value.cust_account_type; // 真实账户传0  虚拟账户传1
      try {
        const params = {
          cmdId: 3911381,
          data: data,
          headerType: 2,
          paramType: 0,
        };
        if (is_try) {
          return Promise.resolve({});
        } else {
          const res: any = await network.request(params);
          if (res && res.type === 'success') {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res.data);
          }
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 账变明细
    // start_time end_time page_start num_per_page trans_type
    async reqBalanceLogs(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data: any = {
        ...payload,
        tid: tenantInfo.value.tid,
        acct_id: userInfo.value.acct_id,
        page_start: payload.page_start || 1,
        num_per_page: payload.num_per_page || 10,
        trans_type: payload.trans_type,
      };
      data.cust_account_type = userInfo.value.cust_account_type; // 真实账户传0  虚拟账户传1
      if (payload.sd_flag) {
        // 刷单项目的账变记录需要传1 其他项目 0
        data.sd_flag = payload.sd_flag;
      }
      if (payload.trans_type && payload.trans_type !== '0') {
        data.trans_type = [];
        data.trans_type[0] = payload.trans_type;
      } else {
        delete data.trans_type;
      }
      try {
        const res = await network.request({
          cmdId: 340333,
          data: data,
          headerType: 2,
          paramType: 0,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
  },
});
